import Form from '../_form';
import Popup from '../../components/popup';

const [ REDIRECTION_TIMEOUT, REDIRECTION_PATH ] = [ 3000, `${window.location.origin}/auth/sign-in` ];

export default class ProfileDeletionForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const reset = this.form.querySelector('.site-button[type="reset"]');

        const popup = new Popup({
            popup: '.site-popup[data-popup="profile-deletion"]',
            toggle: '#profile-deletion-trigger',
            close: '.site-popup-close[data-popup="profile-deletion"]',
            window: '.site-popup-window[data-popup="profile-deletion"]'
        });

        reset.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            popup.close.click();
        });
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const action = formData.get('action');

        try {
            await fetch('/wp-json/user/v1/profile-deletion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ action })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Profile deleted!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    setTimeout(() => window.location.href = REDIRECTION_PATH, REDIRECTION_TIMEOUT);
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
